var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg015Cancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Driver-cancel-booking-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer_Flow-2_03",
    transform: "translate(-162.000000, -242.000000)",
    fill: "#F44336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.5,279 C170.282732,279 162,270.717268 162,260.5 C162,250.282732 170.282732,242 180.5,242 C190.717268,242 199,250.282732 199,260.5 C199,270.717268 190.717268,279 180.5,279 Z M177.807756,260.5 L170.858222,267.449534 L174.128591,270.719903 L181.078125,263.770369 L188.027659,270.719903 L191.298028,267.449534 L184.348494,260.5 L191.298028,253.550466 L188.027659,250.280097 L181.078125,257.229631 L174.128591,250.280097 L170.858222,253.550466 L177.807756,260.5 Z",
    id: "Combined-Shape-Copy",
    transform: "translate(180.500000, 260.500000) rotate(-270.000000) translate(-180.500000, -260.500000) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg015Cancel);
export default __webpack_public_path__ + "static/media/015-cancel.a2cfb99c94fecea948b7b6044073aee1.svg";
export { ForwardRef as ReactComponent };